import { defineMessages } from '../define';

export const common = defineMessages(
  {
    'app.name': 'Karlakór Grafarvogs',
    'app.short': 'Karlakórinn',
    'nav.home': 'Heim',
    'nav.songs': 'Lög',
    'nav.chat': 'Spjall',
    'nav.choir': 'Kórinn',
    'nav.settings': 'Stillingar',
    'nav.admin': 'Stjórnun',
    'common.save': 'Vista',
    'common.saving': 'Vista…',
    'common.saved': 'Vistað',
    'common.cancel': 'Hætta við',
    'common.close': 'Loka',
    'common.dialog': 'Gluggi',
    'common.delete': 'Eyða',
    'common.edit': 'Breyta',
    'common.add': 'Bæta við',
    'common.back': 'Til baka',
    'common.done': 'Lokið',
    'common.ok': 'Í lagi',
    'common.yes': 'Já',
    'common.no': 'Nei',
    'common.search': 'Leita',
    'common.loading': 'Hleð…',
    'common.retry': 'Reyna aftur',
    'common.copy': 'Afrita',
    'common.copied': 'Afritað',
    'common.share': 'Deila',
    'common.more': 'Meira',
    'common.none': 'Ekkert',
    'common.optional': 'valfrjálst',
    'common.confirm_delete': 'Ertu viss um að þú viljir eyða þessu?',
    'common.offline': 'Ekkert netsamband',
    'common.offline_hint': 'Þú ert án nets. Vistuð gögn eru sýnd.',
    'common.no_data_offline': 'Engin gögn vistuð enn – opnaðu appið með nettengingu.',
    'common.error': 'Eitthvað fór úrskeiðis',
    'common.update_available': 'Ný útgáfa – endurhlaða',
    'common.reload': 'Endurhlaða',
    'common.error_body': 'Þessi hluti appsins gat ekki birst. Reyndu aftur eða farðu á forsíðuna.',
    'common.crash_body': 'Appið lenti í villu. Endurhlaðaðu til að halda áfram.',
    'common.chunk_title': 'Endurhlaða þarf appið',
    'common.chunk_body': 'Ekki tókst að sækja þennan hluta appsins – líklega er komin ný útgáfa. Endurhlaðaðu til að halda áfram.',
    'common.offline_unavailable_title': 'Ekki tiltækt án nets',
    'common.offline_unavailable': 'Þessi hluti appsins er ekki vistaður á tækinu. Tengstu netinu og reyndu aftur.',
    'common.privacy_read': 'Lesa persónuverndarstefnuna',
    'section.T1': 'Tenór 1',
    'section.T2': 'Tenór 2',
    'section.B1': 'Bassi 1',
    'section.B2': 'Bassi 2',
    'section.conductor': 'Stjórnandi',
    'section.musician': 'Hljóðfæraleikari',
    'section.musicians': 'Hljóðfæraleikarar',
    'section.none': 'Engin rödd',
    'section.short.T1': 'T1',
    'section.short.T2': 'T2',
    'section.short.B1': 'B1',
    'section.short.B2': 'B2',
    'section.short.conductor': 'Stj.',
    'section.short.musician': 'Hljóðf.',
    'audience.all': 'Allur kórinn',
    'role.member': 'Félagi',
    'role.editor': 'Ritstjóri',
    'role.admin': 'Kerfisstjóri',
    'error.bad_request': 'Ógild beiðni.',
    'error.validation': 'Athugaðu innslegin gögn.',
    'error.unauthorized': 'Þú þarft að skrá þig inn.',
    'error.forbidden': 'Þú hefur ekki aðgang að þessu.',
    'error.not_found': 'Fannst ekki.',
    'error.conflict': 'Árekstur – reyndu aftur.',
    'error.gone': 'Ekki lengur til.',
    'error.too_many_requests': 'Of margar tilraunir. Bíddu aðeins og reyndu aftur.',
    'error.unsupported_media_type': 'Óstudd skráartegund.',
    'error.payload_too_large': 'Skráin er of stór.',
    'error.quota_exceeded': 'Geymslupláss kórsins er fullt.',
    'error.invalid_credentials': 'Rangt netfang eða lykilorð.',
    'error.token_invalid': 'Hlekkurinn er útrunninn eða hefur þegar verið notaður.',
    'error.host_not_allowed': 'Þessi slóð má ekki nota kerfið.',
    'error.csrf': 'Beiðni hafnað af öryggisástæðum.',
    'error.last_admin': 'Það verður að vera a.m.k. einn kerfisstjóri.',
    'error.internal': 'Villa á netþjóni. Reyndu aftur síðar.',
    'error.network': 'Náði ekki sambandi við netþjón.',
  },
  {
    'app.name': 'Karlakór Grafarvogs',
    'app.short': 'Karlakórinn',
    'nav.home': 'Home',
    'nav.songs': 'Songs',
    'nav.chat': 'Chat',
    'nav.choir': 'Choir',
    'nav.settings': 'Settings',
    'nav.admin': 'Admin',
    'common.save': 'Save',
    'common.saving': 'Saving…',
    'common.saved': 'Saved',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.dialog': 'Dialog',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.add': 'Add',
    'common.back': 'Back',
    'common.done': 'Done',
    'common.ok': 'OK',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.search': 'Search',
    'common.loading': 'Loading…',
    'common.retry': 'Try again',
    'common.copy': 'Copy',
    'common.copied': 'Copied',
    'common.share': 'Share',
    'common.more': 'More',
    'common.none': 'None',
    'common.optional': 'optional',
    'common.confirm_delete': 'Are you sure you want to delete this?',
    'common.offline': 'No connection',
    'common.offline_hint': 'You are offline. Showing saved data.',
    'common.no_data_offline': 'Nothing saved yet – open the app while online.',
    'common.error': 'Something went wrong',
    'common.update_available': 'New version – reload',
    'common.reload': 'Reload',
    'common.error_body': 'This part of the app could not be shown. Try again or go to the home screen.',
    'common.crash_body': 'The app ran into an error. Reload to continue.',
    'common.chunk_title': 'The app needs to reload',
    'common.chunk_body': 'This part of the app could not be loaded – probably because a new version is available. Reload to continue.',
    'common.offline_unavailable_title': 'Not available offline',
    'common.offline_unavailable': 'This part of the app is not saved on this device. Connect to the internet and try again.',
    'common.privacy_read': 'Read the privacy policy',
    'section.T1': 'Tenor 1',
    'section.T2': 'Tenor 2',
    'section.B1': 'Bass 1',
    'section.B2': 'Bass 2',
    'section.conductor': 'Conductor',
    'section.musician': 'Musician',
    'section.musicians': 'Musicians',
    'section.none': 'No section',
    'section.short.T1': 'T1',
    'section.short.T2': 'T2',
    'section.short.B1': 'B1',
    'section.short.B2': 'B2',
    'section.short.conductor': 'Cond.',
    'section.short.musician': 'Mus.',
    'audience.all': 'Whole choir',
    'role.member': 'Member',
    'role.editor': 'Editor',
    'role.admin': 'Administrator',
    'error.bad_request': 'Invalid request.',
    'error.validation': 'Please check your input.',
    'error.unauthorized': 'Please sign in.',
    'error.forbidden': 'You do not have access to this.',
    'error.not_found': 'Not found.',
    'error.conflict': 'Conflict – please try again.',
    'error.gone': 'No longer available.',
    'error.too_many_requests': 'Too many attempts. Please wait and try again.',
    'error.unsupported_media_type': 'Unsupported file type.',
    'error.payload_too_large': 'The file is too large.',
    'error.quota_exceeded': "The choir's storage is full.",
    'error.invalid_credentials': 'Wrong e-mail or password.',
    'error.token_invalid': 'The link has expired or was already used.',
    'error.host_not_allowed': 'This address may not use the app.',
    'error.csrf': 'Request rejected for security reasons.',
    'error.last_admin': 'There must be at least one administrator.',
    'error.internal': 'Server error. Please try again later.',
    'error.network': 'Could not reach the server.',
  },
);
